// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function PencilErase(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "PencilErase" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M11.75 18.25H22V20.75H11.75V18.25Z", fill: "currentColor" }),
            React.createElement("path", { d: "M1.75 18.25H5.25V20.75H1.75V18.25Z", fill: "currentColor" }),
            React.createElement("path", { d: "M22.25 6.25L11.75 16.75L8.75 13.75L19.25 3.25L22.25 3.25V6.25Z", fill: "currentColor" }),
            React.createElement("path", { d: "M6.07289 16.309C5.64237 16.7396 5.64237 17.4376 6.07289 17.8681L7.63192 19.4271C8.06244 19.8576 8.76044 19.8576 9.19096 19.4271L10.75 17.8681L7.63192 14.75L6.07289 16.309Z", fill: "currentColor" }))));
});
//# sourceMappingURL=PencilErase.js.map